import * as yup from 'yup';

export const addInstructorsValidationSchema = yup.object({
  emails: yup
    .string()
    .required('Please provide at least one email address.')
    .matches(
      /^[\w%+.-]+@[\d.A-Za-z-]+\.[A-Za-z|]{2,}(\s*,\s*[\w%+.-]+@[\d.A-Za-z-]+\.[A-Za-z|]{2,})*$/,
      'Invalid email address(es).',
    )
    .test({
      name: 'is-valid-email',
      message: 'One or more email addresses are invalid.',
      test: (value = '') => {
        const emails = value.split(',').map((email) => email.trim());
        return emails.every((email) => yup.string().email().isValidSync(email));
      },
    }),
});
